const tryRequire = require('try-require');

module.exports = function (state, opts, config) {
  const HtmlWebpackPlugin = tryRequire('html-webpack-plugin')
  const ResourceHintWebpackPlugin = tryRequire('resource-hints-webpack-plugin')
  const FURTHER_REF = state.FURTHER_REF

  if (!HtmlWebpackPlugin || !ResourceHintWebpackPlugin) {
    return {} // waiting for an installation
  }

  // HTML plugin
  config.plugins.push(new HtmlWebpackPlugin({
    title: opts.name || 'index',
    filename: 'main/index.html',
    template: './src/client/main/templates/index.html',
    templates: [
      './src/client/components/**/*.html',
    ],
    inject: true,
    excludeAssets: [/style([\.\-].*)?\.js/, /\.DS_Store/],
    minify: state.IS_DEV ? false : {
      caseSensitive: true,
      collapseBooleanAttributes: true,
      collapseWhitespace: true,
      conservativeCollapse: true,
      minifyCSS: true,
      minifyJS: true,
      removeAttributeQuotes: true,
      removeComments: true,
      removeScriptTypeAttributes: true,
      // removeStyleLinkTypeAttributes: true,
      sortAttributes: true,
      sortClassName: true,
      useShortDoctype: true
    },
    chunksSortMode: function (chunk1, chunk2) {
      /**
       * We will sort the dependencies following these rules:
       * 
       * - Vendors come first (for rests and libs for exampe)
       * - Main styles come first
       * - Component styles come second (taking care of precedences)
       * - Main scripts come first
       * - Component scripts come later
       */
      const chunkPart1 = chunk1.names[0]
      const chunkPart2 = chunk2.names[0]
      if (chunkPart1.startsWith('vendor')) {
        return -9
      }
      if (chunkPart2.startsWith('vendor')) {
        return 9
      }
      if (chunkPart1.startsWith('main')) {
        if (chunkPart1.endsWith('.js')) {
          return -2
        }
        return -5
      }
      if (chunkPart2.startsWith('main')) {
        if (chunkPart2.endsWith('.js')) {
          return 2
        }
        return 5
      }
      return -1
      // let order2 = orders.indexOf(chunk2.names[0]);

      // return order1 - order2;
    },
    prefetch: ['**/*.woff', '**/*.otf', '**/*.ttf', '**/*.'],
    preload: ['/vendors/**/*.js', '/main/**/*.js', '/main/**/*.css'],
    alwaysWriteToDisk: true,
    chunks: {
      head: {},
      main: {}
    }
  }))
  config.plugins.push(new ResourceHintWebpackPlugin())

  return {
      test: /\.(html|htm)$/,
      use: {
          loader: FURTHER_REF + 'html-loader?interpolate',
          options: {
              attrs: [':data-src']
          }
      }
  }
}



// WEBPACK FOOTER //
// ./src/technologies/html.js